import React from 'react';
import { Container } from 'react-bootstrap';
import PhotoGrid from '../components/PhotoGrid';
import { galleryPhotos } from '../data/gallery';

// One album rather than a shelf of them: the photos span several festivals,
// they all look like the same happy day, and splitting them by year only made
// visitors click twice to see the same thing.
const Gallery: React.FC = () => (
  <section className="section">
    <Container>
      <div className="text-center">
        <h1 className="section-title">Photo Gallery</h1>
        <hr className="section-rule" />
        <p className="lede mx-auto mb-4">
          Photographs from the Art on the Lake Festival at Copper Creek Lake Park in Pleasant Hill.
        </p>
      </div>

      <PhotoGrid photos={galleryPhotos} />
    </Container>
  </section>
);

export default Gallery;
